import { TherapyJobStatus } from '../enums/TherapyJobStatus';

export enum DashboardColumn {
  PRESCRIBED = 'PRESCRIBED',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED'
}

export const DASHBOARD_COLUMNS = {
  [DashboardColumn.PRESCRIBED]: [TherapyJobStatus.PRESCRIBED],
  [DashboardColumn.RUNNING]: [TherapyJobStatus.RUNNING],
  [DashboardColumn.COMPLETED]: [
    TherapyJobStatus.COMPLETED,
    TherapyJobStatus.COMPLETE_CONFIRMED,
    TherapyJobStatus.ABORTED
  ]
};
